{
  "en": {
    "schoolClass": {
      "actions": {
        "leave": "Leave Shared Space"
      },
      "activityViewer": {
        "createdAt": "{dateTime}",
        "createdAtTwelveHour": "{dateTime}",
        "breadcrumb": {
          "activities": "Activities"
        },
        "navigation": {
          "previous": "Previous Activity",
          "next": "Next Activity"
        },
        "export": {
          "document": "Save Document",
          "audio": "Save Audio File",
          "image": "Save Image"
        },
        "placeholder": {
          "unknownPupil": "Unknown",
          "unknownWorksheet": "Unknown Worksheet"
        },
        "worksheet": {
          "submission": "Submission: {worksheetName}",
          "goToDetailView": "Go to Detail View"
        },
        "pupilFeedback": {
          "submission": "Submission: {assignmentName}",
          "unknownAssignment": "Unknown Assignment",
          "averageScore": "Avg. Score:",
          "feedbackLabel": "Feedback",
          "goToDetailView": "Go to Detail View"
        },
        "error": {
          "loadingActivities": "Error loading activities. Please try again.",
          "activityNotFound": "Activity not found."
        },
        "converter": {
          "additionalInfo": "Additional info and target audience",
          "source": "Source",
          "result": "Result",
          "noAudio": "No audio file available",
          "noOutputText": "No output text available",
          "labels": {
            "text": "Result",
            "transcript": "Transcript",
            "summary": "Summary",
            "translation": "Translation",
            "audio": "Audio",
            "podcast": "Podcast",
            "lecture": "Lecture",
            "dialog": "Dialog"
          }
        },
        "textEditor": {
          "untitled": "Untitled Document"
        },
        "pinboardCard": {
          "noContent": "This card has no content.",
          "goToCard": "To the map"
        },
        "pinboardComment": {
          "noContent": "This comment has no content.",
          "goToCard": "To the map"
        },
        "pinboardList": {
          "description": "This list arranges cards on a pinboard and contains no content itself.",
          "goToBoard": "To the Pinboard"
        },
        "surveyResponse": {
          "anonymous": "No detailed view available — survey submissions are anonymous.",
          "goToResponses": "To the results overview"
        },
        "wordEntry": {
          "wordCloudLabel": "in word cloud:",
          "goToWordCloud": "To the Word Cloud"
        }
      },
      "activityContent": {
        "loading": "Loading content...",
        "notSupported": "Preview not available yet",
        "comingSoon": "This tool preview will be available soon",
        "emptyState": "No content available",
        "errors": {
          "unauthorized": "You don't have permission to view this content",
          "notFound": "This content is no longer available",
          "loadFailed": "Failed to load content",
          "unexpected": "An unexpected error occurred"
        },
        "chat": {
          "emptyState": "No messages in this conversation"
        },
        "textEditor": {
          "emptyState": "This document is empty"
        },
        "worksheet": {
          "noContent": "No content to display"
        }
      },
      "activities": {
        "actions": {
          "downloadImage": "Download Image"
        },
        "labels": {
          "name": "Name",
          "content": "Content",
          "project": "Project",
          "access": "Access",
          "createdAt": "Created At",
          "viewActivity": "View Activity"
        },
        "itemTitles": {
          "pinboardCard": "New card \"{name}\"",
          "pinboardList": "New list \"{name}\"",
          "pinboardComment": "New comment on \"{name}\"",
          "surveyResponse": "New submission \"{name}\"",
          "wordEntry": "New entry \"{name}\""
        },
        "saveConversation": "Download conversation",
        "saveDocument": "Download document",
        "saveResponse": "Download response",
        "saveResult": "Download result",
        "sectionTitle": "Recently created",
        "projectSectionTitle": "Activities in this project",
        "projectSectionTooltip": "Click on an activity to open the details. You can easily download submissions and AI chat histories via the 3-dot menu.",
        "emptyState": "There are no activities yet. Once you start working on a project, you'll see your activities here.",
        "projectEmptyState": "There are no activities in this project yet. Once your students start working on the project, their activities will appear here.",
        "filters": {
          "ariaLabel": "Filter activities",
          "title": "Filter activities",
          "all": "All",
          "access": {
            "title": "Access",
            "label": "Select access…",
            "ariaLabel": "Filter by access"
          },
          "content": {
            "title": "Content",
            "label": "Content"
          },
          "status": {
            "title": "Status",
            "label": "Status",
            "ariaLabel": "Filter by status",
            "completed": "Completed",
            "open": "Open"
          },
          "timeframe": {
            "title": "Period",
            "label": "Period",
            "totalPeriod": "Entire period",
            "last7Days": "Last 7 days",
            "last30Days": "Last 30 days",
            "thisYear": "This year ({year})",
            "lastYear": "Last year ({year})",
            "customRange": "Set period"
          }
        }
      },
      "activity": {
        "addPupil": "Add access",
        "downloadCodes": "Show list"
      },
      "alert": {
        "discardedMembershipTitle": "You are no longer an active member of this space.",
        "discardedMembershipBody": "All your projects have been closed. Without active membership, you cannot create new projects.",
        "discardedMembershipProjectBody": "Without an active membership, you can no longer open this project. Rejoin the Shared Space to regain access.",
        "sharedClassroomAccessItem1": "Students always log in at <a href='https://go.fobizz.com' target='_blank'>go.fobizz.com</a>. In case a student loses their code, you can find it here.",
        "sharedClassroomAccessItem2": "<strong>Please be careful</strong>: All educators use the same codes for all students in a shared space. Make sure to <strong>coordinate</strong> any <strong>changes</strong> to the list with all colleagues who use this shared space.",
        "sharedClassroomAccessTitle": "Managing student access in shared spaces used by multiple educators"
      },
      "classroom": {
        "create": "Create Shared Space",
        "createDescription": "Share assignments with your students and provide AI tools and material for them to work with.",
        "links": {
          "new": "New Shared Space",
          "back": "Back",
          "discardedProjects": "Closed projects",
          "pausedProjectsTab": "Paused Projects",
          "activeProjects": "Current projects",
          "projects": "Projects",
          "currentProject": "Project",
          "members": "Teachers",
          "accessCodes": "Participants"
        },
        "projectFilter": {
          "ariaLabel": "Filter projects by status",
          "all": "All",
          "active": "Active",
          "paused": "Paused",
          "ended": "Completed"
        },
        "info": {
          "classroom": {
            "heading": "This is how you share this space",
            "listItems": "<ol><li>Print the class list with access codes and make a note of who is who. This keeps the data protected.</li><li>Distribute the access codes. Each person receives their own access code, valid for the entire school year.</li><li>On <a href='https://go.fobizz.com'>go.fobizz.com</a>, students log in using their access code to view and edit active projects.</li></ol>",
            "manage": "Manage",
            "showAccessCodes": "Show access codes"
          },
          "index": {
            "body": "In shared spaces, your students can work independently and securely with digital tools and AI. You can choose between the following options:",
            "heading": "Tools and AI for your class",
            "option1": "<strong class=\"fw-semibold\">Shared space for 1 year</strong>, multiple projects, individual access code for each student, deletion after 365 days",
            "option2": "<strong class=\"fw-semibold\">Shared space for 24 h</strong>, one single project, one access link for everyone, deletion after 24 h"
          }
        },
        "labels": {
          "activateControls": {
            "hours24": "24 hr",
            "hours24WithMaximum": "24 hr",
            "hours24Full": "24 hours",
            "oneMonthWithMaximum": "1 month",
            "extend": "Extend",
            "reactivate": "Reactivate",
            "stop": "Pause"
          },
          "model": {
            "name": "Shared space name",
            "namePlaceholder": "Enter name...",
            "studentAccess": "Student Access"
          },
          "school": "School",
          "shareHint": "You can share the Shared Space with colleagues after creating it. You will find the invitation link in the \"Teachers\" section.",
          "studentAccessTooltip": "Number of students who can work simultaneously in this shared space. Each person receives an individual access code.",
          "schoolPlaceholder": "Select school..."
        },
        "indexTitle": "Shared Spaces",
        "pageTitle": "My Shared Spaces",
        "pupil": {
          "loggedInAs": "Logged in as",
          "logout": "Logout"
        }
      },
      "confirmDialog": {
        "deletePupil": {
          "confirmButton": "Delete",
          "text": "This action cannot be undone. The access code will be deleted and can no longer be used to log in.",
          "title": "Delete access?"
        },
        "deleteTemplate": {
          "confirmButton": "Delete",
          "text": "This action cannot be undone. The template will be permanently deleted and will no longer be available for new projects.",
          "title": "Delete project template?"
        },
        "discardProject": {
          "confirmButton": "Delete",
          "text": "This action cannot be undone. The project will be permanently deleted.",
          "title": "Delete project?"
        },
        "finishProject": {
          "confirmButton": "End",
          "text": "The project will be ended and moved to the archive. You will find it under the archived projects of the Shared Space.",
          "title": "End project?"
        },
        "leave": {
          "confirmButton": "Leave",
          "text": "You will no longer have access to the Shared Space and its contents.",
          "title": "Leave Shared Space?"
        },
        "saveAsTemplate": {
          "confirmButton": "Save",
          "text": "The project will be saved as a template and separated from the Shared Space.",
          "title": "Save project as template?"
        }
      },
      "download": {
        "abbreviation": "Abbreviation",
        "accessCode": "Access Code",
        "accessCodesForClass": "Access codes for",
        "accessCreationInstruction": "On app.fobizz.com, you can easily create additional access codes for this Shared Space in the overview.",
        "accessListForClass": "Access list for",
        "documentNotice": "This document is intended for your personal records only and must be treated confidentially. Bear in mind to never share personal data of your students online.",
        "goToInstruction": "Go to:",
        "needMoreAccess": "Do you need more access?",
        "note": "Note",
        "yourAbbreviation": "Your abbreviation: ",
        "yourAccessCode": "Your access code: "
      },
      "errors": {
        "createFailed": "Could not create project."
      },
      "flash": {
        "accessCodeCopied": "Access code copied to clipboard",
        "createSuccess": "Project was successfully created.",
        "deactivatePupilFailure": "Could not deactivate account.",
        "deactivatePupilSuccess": "Account was successfully deactivated.",
        "deactivateTeacherFailure": "Could not deactivate teacher access.",
        "deactivateTeacherSuccess": "Teacher access was successfully deactivated.",
        "deletePupilFailure": "Could not delete account.",
        "deletePupilSuccess": "Account was successfully deleted.",
        "leaveFailure": "Failed to leave the shared space.",
        "leaveSuccess": "Successfully left the shared space.",
        "finishProjectSuccess": "Project completed successfully.",
        "pauseProjectSuccess": "Project successfully paused.",
        "resumeProjectSuccess": "Project successfully activated.",
        "extendProjectSuccess": "Project successfully extended.",
        "restoreProjectSuccess": "Project successfully restored.",
        "shareProjectSuccess": "Your project was successfully shared.",
        "shareProjectFailure": "The project could not be shared.",
        "privateItem": "The privacy policy for this content has been updated.",
        "reactivatePupilFailure": "Could not reactivate access.",
        "reactivatePupilSuccess": "Access was successfully reactivated.",
        "reactivateTeacherFailure": "Could not reactivate teacher access.",
        "reactivateTeacherSuccess": "Teacher access was successfully reactivated.",
        "regenerateTokenFailure": "Could not regenerate access code.",
        "regenerateTokenSuccess": "Access code was successfully regenerated.",
        "remixedItem": "This AI assistant has been remixed for you and copied to your account.",
        "updateSchoolClassSuccess": "Shared Space was successfully updated.",
        "copyError": "Error copying to clipboard.",
        "noAccessCode": "No access code available.",
        "deleteFailed": "Could not delete project.",
        "createFromTemplateFailed": "Could not create project from template.",
        "saveAsTemplateSuccess": "Project was successfully saved as a template.",
        "saveAsTemplateFailed": "Could not save project as template.",
        "deleteTemplateSuccess": "Template was successfully deleted.",
        "deleteTemplateFailed": "Could not delete template.",
        "updateTemplateSuccess": "Project template updated successfully.",
        "updateTemplateFailed": "Could not update project template."
      },
      "hints": {
        "aiChatAlert": "Chat with AI allows students to create their own AI assistants.",
        "projectFiles": "Upload files that your students can view and download in the project.",
        "projectItems": "Share up to 10 materials/assistants with students.",
        "projectTools": "Due to technical and data privacy limitations, only the specified tools can currently be made available for students."
      },
      "labels": {
        "inactivePupil": "Access disabled",
        "owner": "Admin",
        "pupilName": "Name",
        "showQrCode": "Show QR code",
        "activity": "Activity",
        "totalToolsCount": "activity | activities",
        "createdAt": "Created at"
      },
      "members": {
        "actions": {
          "discard": "Deactivate Access",
          "undiscard": "Reactivate Access"
        },
        "status": {
          "header": "Access",
          "active": "Access active",
          "deactivated": "Access disabled"
        },
        "empty": "No teachers added yet",
        "schoolAccessExpired": {
          "title": "Invitations not possible",
          "text": "This Shared Space belongs to the school \"{companyName}\", which no longer has an active Shared Spaces licence. Colleagues can therefore no longer be invited.",
          "textWithoutSchool": "This Shared Space no longer has an active Shared Spaces licence. Colleagues can therefore no longer be invited."
        },
        "invite": {
          "title": "Invite teachers to the Shared Space",
          "titleShort": "Invite teachers",
          "tooltip": "The invitation is only valid for this Shared Space. The link is general and not personalized.",
          "retry": "Generate invitation link",
          "regenerate": "Regenerate",
          "showQrCode": "Show QR code",
          "qrCodeTitle": "QR Code",
          "qrCodeAlt": "QR code for the invitation link",
          "confirmRegenerate": {
            "title": "Regenerate invitation link",
            "text": "Here you can regenerate the invitation link for the Shared Space. Please note that the old link will become invalid.",
            "confirm": "Yes, regenerate"
          },
          "flash": {
            "generateFailure": "Invitation link could not be created.",
            "regenerateSuccess": "Invitation link has been regenerated.",
            "regenerateFailure": "Invitation link could not be regenerated."
          }
        }
      },
      "modals": {
        "deleteConfirmation": {
          "confirmButton": "Delete",
          "projectsInfo": "all active projects (currently {count})",
          "subtitle": "Are you sure you want to delete the shared space {schoolClassName}?",
          "text": "The shared space will be deleted for all participating teachers.",
          "textWithProjects": "The shared space will be deleted for all participating teachers. Additionally, {projectsInfo} will be automatically closed.",
          "title": "Delete Shared Space?"
        }
      },
      "project": {
        "create": "Create new project",
        "defaults": {
          "descriptionPlaceholder": "Here you can describe your assignment in more detail.",
          "name": "Project name",
          "projectNamePlaceholder": "Assignment name here..."
        },
        "heading": {
          "noProject": "Time for a break",
          "createFromTemplate": "AI Introduction for Students"
        },
        "share": {
          "button": "Share",
          "dialogTitle": "Share this project with your colleagues",
          "dialogDescription": "Here you can add teachers from the Shared Space {schoolClassName} to the project {projectName}.",
          "dialogDescriptionNoClass": "Here you can add teachers to the project {projectName}."
        },
        "errors": {
          "fileAttachFailed": "\"{filename}\" could not be added to the project. Please check the file type and size.",
          "fileRemoveFailed": "The file could not be removed. Please try again.",
          "imageUpdateFailed": "The project image could not be saved. Please try again.",
          "itemLoadFailed": "The material to be shared could not be loaded. You can select it via \"Add content\".",
          "itemUnlockFailed": "The project was created, but the sharing settings of the material could not be updated. Please check them in the material."
        },
        "hints": {
          "dropFile": "Drag & drop here or select a file.",
          "projectItemsLimitReached": "You have reached the maximum number of items to share (10). Delete one to select a new one."
        },
        "labels": {
          "activeShort": "Active for",
          "chatFrom": "Chat from",
          "createdBy": "By {name}",
          "dayLabel": "day | days",
          "description": "Assignment",
          "completed": "Completed",
          "discardedAt": "Project closed",
          "enabledTools": "Enabled tools",
          "members": "Add teacher",
          "membersPlaceholder": "Select...",
          "membersNoOptions": "Please add teachers to the Shared Space first",
          "membersAllAdded": "All teachers have already been added to the Shared Space",
          "membersTooltip": "All teachers invited to this Shared Space can be added to a single project.",
          "end": "End project",
          "feedbackGiven": "Feedback given",
          "files": "Files",
          "history": "Progress and submissions",
          "replaceImage": "Replace image",
          "teachers": "Teachers",
          "restore": "Restore project",
          "hourLabel": "hr",
          "noProject": "There are currently no assignments for you.",
          "noArchivedProjects": "No finished projects yet.",
          "on": "at",
          "pausedPupil": "Your teacher can reactivate the project.",
          "projectItemResponseSubmissions": "{count} submission | {count} submissions",
          "projectActive": "Project active",
          "projectActiveFor": "Project active for",
          "projectItems": "Materials and assistants",
          "projectPaused": "Project paused",
          "pausedShort": "Paused",
          "projectPausedSentence": "Project is paused.",
          "pupil": {
            "accessCode": "Access code:",
            "deactivate": "Deactivate account",
            "delete": "Delete account",
            "downloadList": "Show list",
            "reactivate": "Reactivate account",
            "regenerateToken": "Regenerate access code"
          },
          "draftFrom": "Draft from",
          "submittedOn": "Submitted on"
        },
        "links": {
          "new": "Create project",
          "newEmpty": "Empty project",
          "newFromTemplate": "Create project from template",
          "open": "Open project",
          "remove": "Delete project",
          "saveAsTemplate": "Save as template"
        },
        "paragraphs": {
          "createTile": "Share an assignment and the specific tools and materials to complete it.",
          "createFromTemplateTile": "Use our prepared introductory course to teach the basics of AI literacy.",
          "templateModalDescription": "Select a template to create a ready-made project for your shared space.",
          "pupil": {
            "empty": "There are no participants in this shared space yet. Share the access link to get started."
          }
        },
        "picker": {
          "addButton": "Add content",
          "assistantCatalog": {
            "empty": "No assistants found.",
            "errorLoading": "The assistants could not be loaded.",
            "tabLabel": "Assistants Catalog"
          },
          "dialogTitle": "Add content",
          "limitHint": "Maximum {max} items per project. Select fewer.",
          "myContent": {
            "tabLabel": "My Shared Spaces"
          },
          "searchPlaceholder": "Search content..."
        },
        "pupil": {
          "enabledTools": "Enabled Tools",
          "warning": {
            "text": "{title} Your teacher can view your current work status at any time.",
            "title": "Good to know:"
          }
        },
        "shareAlertHeadline": "Access for all participants:"
      },
      "projectTemplates": {
        "heading": "Project Templates",
        "breadcrumb": "Project Templates"
      },
      "consentModal": {
        "acknowledge": {
          "hint": "Tap here to confirm",
          "label": "Got it, understood"
        },
        "start": "Let's go"
      },
      "inviteRedeem": {
        "title": "Invitation to Shared Space {name}",
        "body": "{inviter} has invited you to the Shared Space {name}.",
        "bodyNoInviter": "You have been invited to the Shared Space {name}.",
        "join": "Join Shared Space",
        "decline": "Decline",
        "invalidTitle": "This invitation link is no longer valid.",
        "invalidSubtitle": "Please ask the staff for a new invitation link.",
        "expiredTitle": "The link has expired",
        "expiredSubtitle": "The person managing the Shared Space can send you the current link.",
        "expiredConfirm": "OK",
        "errorTitle": "The invitation could not be loaded.",
        "errorSubtitle": "Please check your connection and try again.",
        "retry": "Try Again",
        "backToOverview": "To \"Workspace\"",
        "licenseActivateTitle": "1/2 Activate license group",
        "licenseActivateBody": "{inviter} has invited you to the Shared Space {name}.{break}You need a {license} to use the Shared Spaces.",
        "licenseActivateBodyNoInviter": "You have been invited to the Shared Space {name}.{break}You need a {license} to use the Shared Spaces.",
        "licenseActivateDifferentSchoolBody": "{inviter} has invited you to the Shared Space {name}.{break}Your active license does not belong to the school's Shared Space.",
        "licenseActivateDifferentSchoolBodyNoInviter": "You have been invited to the Shared Space {name}.{break}Your active license does not belong to the school's Shared Space.",
        "licenseCodeLabelForSchool": "Do you have an 8-digit activation code for the license group {school}?",
        "licenseWrongSchoolTitle": "The activation code you used is valid for a different license group.",
        "licenseWrongSchoolBody": "For the Shared Space invitation from {inviter}, you need the activation code for the license group {school}.",
        "licenseWrongSchoolBodyNoInviter": "For the Shared Space invitation, you need the activation code for the license group {school}.",
        "licenseWrongSchoolBodyNoSchool": "For the Shared Space invitation from {inviter}, you need the activation code for the correct license group.",
        "licenseJoinTitle": "2/2 Join Shared Space",
        "licenseJoinBody": "{inviter} has invited you to the Shared Space {name}. Join the Shared Space now for shared project use.",
        "licenseJoinBodyNoInviter": "You have been invited to the Shared Space {name}. Join the Shared Space now for shared project use.",
        "licenseName": "fobizz license",
        "licenseCodeLabel": "Do you already have an 8-digit activation code?",
        "activateLicense": "Activate license",
        "moreAboutGroupLicense": "More about group license",
        "groupLicenseUrl": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/",
        "flash": {
          "joinSuccess": "Invitation accepted – Welcome to the Shared Space {name}",
          "joinFailure": "Joining failed. Please try again.",
          "declined": "Shared Space invitation was declined.",
          "alreadyMember": "You are already a member of the Shared Space {name}.",
          "differentSchool": "This code belongs to another school. Joining this Shared Space is not possible.",
          "licenseActivated": "License group {group} successfully activated."
        },
        "bodyNoGroup": "{inviter} has invited you to the Shared Space {name}.",
        "licenseRequired": "To use the Shared Spaces, you need a fobizz license."
      }
    }
  }
}
